import React from "react";

const CriticalEvent = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 40 40"
      className={props.className || ""}
      style={{ fontSize: props.fontSize || "20px", pointerEvents: props.pointerEvents || "none" }}
    >
      <circle
        cx="20"
        cy="20"
        r="18"
        strokeWidth="2"
      />
      <polygon
        points="20,2 24.76,14.14 38,14.14 27.12,22.36 31.88,34.5 20,26.28 8.12,34.5 12.88,22.36 2,14.14 15.24,14.14"
        fill="white"
      />
    </svg>
  );
};

export default CriticalEvent;
